export default __webpack_public_path__ + "static/media/move-mc.bcdb2b57.gif";